import { render, staticRenderFns } from "./modal-two-horizontal-btn.mpx?vue&type=template&id=4ea2e15c&isComponent&outputPath=components%2Fmodal-two-horizontal-btn6c533839%2Findex"
import script from "./modal-two-horizontal-btn.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-two-horizontal-btn6c533839%2Findex"
export * from "./modal-two-horizontal-btn.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-two-horizontal-btn6c533839%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports